<template>
    <div class="bg-white m-0">
        <CContainer>
            <CRow>
                <CCol sm="12">
                    <div class="custom-40px-600 text-center mt-5">MyReport</div>
                    <div class="text-center">
                        <label class="m-3 font-color-171717">About Us</label
              >
    
              <label class="m-3 font-color-171717"
                >Products</label
              >
    
              <label class="m-3 font-color-171717"
                >Services</label
              >
    
              <label class="m-3 font-color-171717"
                >Contact</label
              >
    
              <label class="m-3 font-color-171717"
                >FAQ</label
              >
            </div>
              <br />
           
             
            </CCol>
    
         
          
          </CRow>
        </CContainer>
        <hr />
        <CRow>
          <CCol sm="6"><label class="m-3 font-color-171717">© 2023 MyReport.ai. All rights reserved.</label></CCol>
                <CCol sm="6">
                    <div class="text-right"><label class="m-3 font-color-171717">Privacy Policy</label
              >
    
              <label class="m-3 font-color-171717"  @click="GoToLegal()"
                >Terms and Conditions</label
              >
    
              <label class="m-3 font-color-171717"
                >Cookie Policy</label
              >
            </div> </CCol>
        </CRow>
        <div class="chat-container" v-show="isChatVisible">
            <div class="chat-header">
                <h3 class="custom-16px-500 text-left p-2">Messages</h3>
            </div>
            <div class="messages p-2">
                <div v-for="(msg, index) in filteredMessages" :key="index" :class="['message', msg.isUser ? 'user-message' : 'bot-message']">
                    <strong v-if="!msg.isUser"></strong> {{ msg.text }}
                </div>
                <!-- If user hasn't entered name yet, show input to ask for name -->
                <div v-if="!userKey" class="name-input">
    
                    <div style="display: flex; align-items: center; gap: 10px">
                        <CInput v-model="userFirstName" type="text" placeholder="First name" @keydown.enter="setUserName" />
                        <CInput v-model="userLastName" type="text" placeholder="Last name" @keydown.enter="setUserName" />
                        <img src="../assets/img/send.png" width="30px" height="30px" class="send-icon" @click="setUserName" style="cursor: pointer;" />
                    </div>
                </div>
            </div>
    
            <!-- Message input form -->
            <form @submit.prevent="sendMessage" class="message-form" v-if="userKey">
                <input type="text" v-model="userMessage" placeholder="Send your message" required />
                <img src="../assets/img/send.png" width="30px" height="30px" class="send-icon" @click="sendMessage" />
            </form>
        </div>
    
        <!-- Chat Icon -->
        <div class="chat-icon" @click="toggleChatVisibility">
            <img src="../assets/img/toggle-chat.png" alt="Chat Icon" />
        </div>
      </div>
</template>



<script>
import axios from "axios";
export default {
    name: "TheFooter",
    data() {
        return {
          botToken: "7843663557:AAHHntn1bPWuazRlNwiiJEgVjGz2wkeMhO4", // Your bot token
      chatId: -1002499340521, // Chat ID to be set dynamically
      userKey: "", // User key based on name
            userFirstName: "",
            userLastName: "",
            userMessage: "",
            messages: [],
            lastUpdateId: null,
            isChatVisible: false,

        };
    },
    computed: {
        filteredMessages() {
            return this.messages.filter((msg) => msg.userKey === this.userKey);
        },
    },
    mounted() {
        axios
            .post(`https://api.telegram.org/bot${this.botToken}/deleteWebhook`)
            .then(() => {
                console.log("Webhook deleted, starting to poll for messages.");
            })
            .catch((error) => {
                console.error("Error deleting webhook:", error);
            });
    },
    methods: {
        GoToAbout() {
            this.$router.push("About");
        },
        GoToContact() {
            this.$router.push("ContactUs");
        },
        GoToLegal() {
            this.$router.push("Legal");
        },
        GoToBlog() {
            this.$router.push("Blog");
        },
        GoToLinkedIn() {
            window.open("https://www.linkedin.com/company/70999536/");
        },
        GoToFacebook() {
            window.open("https://www.facebook.com/pickiddo");
        },
        GoToInstagram() {
            window.open("https://www.instagram.com/pickiddo");
        },
        GoToTiktok() {
            window.open("https://www.tiktok.com/@pickiddo");
        },
        GoToYoutube() {
            window.open("https://www.youtube.com/@pickiddo");
        },
        GoToWhatsapp() {
            window.open("https://wa.me/600106597700");
        },

        changeImageSrc() {
            // Change image source to hover image source
            this.imageSrc = this.hoverImageSrc;
        },
        resetImageSrc() {
            // Reset image source to original image source
        },
        changeImageSrcInsta() {
            // Change image source to hover image source
            this.imageSrcInsta = this.hoverImageSrcInsta;
        },
        resetImageSrcInsta() {
            // Reset image source to original image source
        },
        changeImageSrcFb() {
            // Change image source to hover image source
            this.imageSrcFb = this.hoverImageSrcFb;
        },
        resetImageSrcFb() {
            // Reset image source to original image source
        },
        changeImageSrcLn() {
            // Change image source to hover image source
            this.imageSrcLn = this.hoverImageSrcLn;
        },
        resetImageSrcLn() {
            // Reset image source to original image source
        },
        changeImageSrcWs() {
            // Change image source to hover image source
            this.imageSrcWs = this.hoverImageSrcWs;
        },
        resetImageSrcWs() {
            // Reset image source to original image source
        },
        changeImageSrcYou() {
            // Change image source to hover image source
            this.imageSrcYou = this.hoverImageSrcYou;
        },
        resetImageSrcYou() {
            // Reset image source to original image source
        },
     // Method to automatically send the bot's first name request when the chat is opened
     askForName() {
            if (!this.userKey) {
                this.messages.push({
                    text: "Please enter your first name and last name.",
                    isUser: false,
                    senderName: "Bot",
                });
            }
        },

        // Handle sending user messages
        async sendMessage() {
            const message = this.userMessage.trim();
            if (!message) return;

            const messageTextWithName = `${this.userKey}: ${message}`;

            try {
                const url = `https://api.telegram.org/bot${this.botToken}/sendMessage`;
                const payload = {
                    chat_id: this.chatId,
                    text: messageTextWithName,
                };

                const response = await axios.post(url, payload);
                if (response.data.ok) {
                    this.messages.push({
                        text: message,
                        isUser: true,
                        userKey: this.userKey,
                    });
                    this.userMessage = "";
                } else {
                    console.error("Error sending message:", response.data.description);
                }
            } catch (error) {
                console.error("Error sending message:", error);
            }
            this.$nextTick(() => this.scrollToBottom()); // Ensure scroll happens after DOM update
        },

        // Fetch new messages
        async fetchMessages() {
            try {
                const url = `https://api.telegram.org/bot${this.botToken}/getUpdates`;
                const params = this.lastUpdateId ? { offset: this.lastUpdateId + 1 } : {};
                const response = await axios.post(url, params);
                const updates = response.data.result;

                updates.forEach((update) => {
                    if (update.message) {
                        const chatId = update.message.chat.id;
                        const text = update.message.text || "";
                        const senderFirstName = update.message.from.first_name || "";
                        const senderLastName = update.message.from.last_name || "";
                        const senderName = `${senderFirstName} ${senderLastName}`.trim();
                        const userKey = `${senderFirstName}_${senderLastName}`;

                        if (!this.chatId) this.chatId = chatId; // Assign chat ID dynamically

                        if (update.message.reply_to_message) {
                            const repliedText = update.message.reply_to_message.text || "";
                            const repliedUserKey = repliedText.split(":")[0];
                            if (repliedUserKey === this.userKey) {
                                this.messages.push({
                                    text: `Intvrr Team: ${text}`,
                                    isUser: false,
                                    userKey: repliedUserKey,
                                });
                            }
                        } else {
                            this.messages.push({
                                text,
                                isUser: senderName === this.userKey,
                                userKey,
                            });
                        }
                    }
                    this.lastUpdateId = update.update_id;
                });
            } catch (error) {
                console.error("Error fetching messages:", error);
            }
            this.$nextTick(() => this.scrollToBottom()); // Ensure scroll happens after DOM update
        },

        // Toggle the visibility of the chat
        toggleChatVisibility() {
            this.isChatVisible = !this.isChatVisible;
            if (this.isChatVisible) {
                this.askForName(); // Ask for the name when chat opens
                this.fetchMessages(); // Fetch initial messages
                this.fetchInterval = setInterval(this.fetchMessages, 3000); // Poll every 3 seconds
            } else {
                clearInterval(this.fetchInterval);
            }
        },

        // Set the user name and send a welcome message
        setUserName() {
            if (this.userFirstName && this.userLastName) {
                this.userKey = `${this.userFirstName}_${this.userLastName}`;
                this.messages.push({
                    text: `Hello, ${this.userFirstName}! How can I help you today?`,
                    isUser: false,
                    userKey: this.userKey,
                });
                this.userFirstName = "";
                this.userLastName = "";
            }
        },
    selectMessage(msg) {
      this.selectedMessageId = msg.message_id; // Store the message ID to reply to
      this.selectedChatId = msg.chatId; // Store the chat_id of the user who sent the message
    },
    scrollToBottom() {
    this.$nextTick(() => {
      const chatContainer = document.querySelector(".messages");
      if (chatContainer) {
        chatContainer.scrollTop = chatContainer.scrollHeight;
      }
    });
  },

    },
};
</script>

<style>
.pointer:hover {
    cursor: pointer;
    text-decoration: underline;
}

.hover-pointer1 {
    cursor: pointer;
    /* Set cursor to pointer on hover */
}

.hover-pointer2 {
    cursor: pointer;
    /* Set cursor to pointer on hover */
}

.hover-pointer3 {
    cursor: pointer;
    /* Set cursor to pointer on hover */
}

.hover-pointer4 {
    cursor: pointer;
    /* Set cursor to pointer on hover */
}

.hover-pointer5 {
    cursor: pointer;
    /* Set cursor to pointer on hover */
}

.hover-pointer6 {
    cursor: pointer;
    /* Set cursor to pointer on hover */
}

.chat-container {
    display: flex;
    flex-direction: column;
    position: fixed;
    bottom: 120px;
    right: 20px;
    width: 300px;
    height: 400px;
    border-radius: 20px;
    background-color: #f9f9f9;
    border: 1px solid #ddd;
    z-index: 1000;
}

.chat-header {
    color: #171717;
    text-align: left;
    font-size: 12px;
    background: #fff;
    border-top-right-radius: 20px;
    border-top-left-radius: 20px;
    padding: 5px;
    position: sticky;
    top: 0;
    z-index: 2;
    background-color: white;
}

.messages {
    flex-grow: 1;
    overflow-y: auto;
    margin-bottom: 10px;
    padding: 10px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    max-height: 280px;
    /* Adjust based on your design */
    scroll-behavior: smooth;
    /* Enables smooth scrolling */
}

.message {
    max-width: 60%;
    padding: 10px;
    border-radius: 10px;
    word-wrap: break-word;
    display: inline-block;
}

.user-message {
    align-self: flex-start;
    border-radius: 20px;
    background: var(--surface-surface-tertiary, #F5F5F5);
    padding: 10px;
    color: #171717;
}

.bot-message {
    align-self: flex-end;
    border-radius: 20px;
    background: #928AFD;
    padding: 10px;
    color: #fff;
}

.message-form {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px;
    background: #fff;
    border-bottom-right-radius: 20px;
    border-bottom-left-radius: 20px;
}

.message-form input {
    flex-grow: 1;
    padding: 10px;
    font-size: 16px;
    border: 1px solid var(--Grayscale-200, #E5E5E5);
    border-radius: 25px;
    height: 40px;
}

.send-icon {
    cursor: pointer;
}

.chat-icon {
    position: fixed;
    bottom: 20px;
    right: 20px;
    cursor: pointer;
}

.chat-icon img {
    width: 100px;
    height: 100px;
    border-radius: 50%;
}

@import url("https://fonts.googleapis.com/css2?family=Montserrat&family=Poppins&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@100&family=Montserrat&family=Poppins&display=swap");
</style>
  

